import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { EnergyUtils } from '@app/energy/utils/energy.utils';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';

@Component({
    selector: 'app-ots-payment-details-container',
    template: `
        <app-payment-details
            (previous)="goToPrevious()"
            (next)="submit()"
            [energyDomiciliationPaymentMandatory]="energyDomiciliationPaymentMandatory"
        ></app-payment-details>
    `,
})
export class PaymentDetailsContainer implements OnInit {
    public energyDomiciliationPaymentMandatory = false;

    constructor(private readonly route: ActivatedRoute, private readonly router: Router, private readonly moveSandbox: MoveSandbox) {}

    public ngOnInit(): void {
        this.moveSandbox.moveOnce$.subscribe((move) => {
            this.energyDomiciliationPaymentMandatory = EnergyUtils.energyDomiciliationRequired(move);
        });
    }

    public goToPrevious(): void {
        void this.router.navigate(['../contact-details'], {
            relativeTo: this.route,
        });
    }

    public submit(): void {
        const extras: NavigationExtras = {
            relativeTo: this.route,
        };
        void this.router.navigate([`../../other-services`], extras);
    }
}
